import { Injectable } from '@angular/core';
@Injectable()
export class StyleService {
  public constructor() {}

  //Determine if fore color should be dark or light based on luminosity of background color
  public smartForeColor(backgroundColor: string): string {
    if (this.getLuma(backgroundColor) >= 128) return 'rgba(0,0,0,1)';
    else return 'rgba(255,255,255,1)';
  }

  public smartButtonColors(color: string, percentage: number): Array<string> {
    let result = new Array<string>();

    let buttonColor = color;
    let buttonFontColor = '';
    let buttonHoverColor = color;
    let buttonHoverFontColor = '';

    let colorString = color.replace('#', '');
    if (percentage > 1) percentage /= 100;

    let luma = this.getLuma(buttonColor);
    let newLuma = 0;
    let percentChange = 0;

    if (luma >= 128) {
      //set button font color to dark
      buttonFontColor = 'rgba(0, 0, 0, 1)';

      //darken the color
      while (percentChange < percentage) {
        buttonHoverColor = this.darkenHex(buttonHoverColor, percentage);

        newLuma = this.getLuma(buttonHoverColor);
        percentChange = ((newLuma - luma) / luma) * -1;
      }
    } else {
      //set button font color to bright
      buttonFontColor = 'rgba(255, 255, 255, 1)';

      //darken the color
      while (percentChange < percentage) {
        buttonHoverColor = this.lightenHex(buttonHoverColor, percentage);

        newLuma = this.getLuma(buttonHoverColor);
        percentChange = (newLuma - luma) / luma;
      }
    }

    //recalc luminosity for new color and determine font luminosity for hover
    if (this.getLuma(buttonHoverColor) >= 128) buttonHoverFontColor = '#2c2c2c';
    else buttonHoverFontColor = '#ffffff';

    //add results to array
    result.push(buttonColor);
    result.push(buttonFontColor);
    result.push(buttonHoverColor);
    result.push(buttonHoverFontColor);

    return result;
  }

  private darkenHex(color: string, percentage: number): string {
    let colorString = color.replace('#', '');

    let r = parseInt(colorString.substr(0, 2), 16);
    let g = parseInt(colorString.substr(2, 2), 16);
    let b = parseInt(colorString.substr(4, 2), 16);

    percentage = 1 - percentage;

    r = Math.round(r * percentage);
    g = Math.round(g * percentage);
    b = Math.round(b * percentage);

    let rS = r.toString(16);
    let gS = g.toString(16);
    let bS = b.toString(16);

    if (rS.length == 1) rS = '0' + rS;
    if (gS.length == 1) gS = '0' + gS;
    if (bS.length == 1) bS = '0' + bS;

    return '#' + rS + gS + bS;
  }

  private lightenHex(color: string, percentage: number): string {
    let colorString = color.replace('#', '');

    let r = parseInt(colorString.substr(0, 2), 16);
    let g = parseInt(colorString.substr(2, 2), 16);
    let b = parseInt(colorString.substr(4, 2), 16);

    //bump channels up for very dark colors to make changes perceptable
    if (this.getLuma(color) < 40) {
      r += 64;
      g += 64;
      b += 64;
    }

    percentage = 1 + percentage;

    r = Math.round(r * percentage);
    g = Math.round(g * percentage);
    b = Math.round(b * percentage);

    //if a channel exceeds 255, add its overage amount to the other channels to lighten the resulting color
    let overage = 0;
    if (r > 255) overage += r - 255;
    if (g > 255) overage += g - 255;
    if (b > 255) overage += b - 255;

    r = r > 255 ? 255 : r + overage;
    g = g > 255 ? 255 : g + overage;
    b = b > 255 ? 255 : b + overage;

    let rS = r.toString(16);
    let gS = g.toString(16);
    let bS = b.toString(16);

    if (rS.length == 1) rS = '0' + rS;
    if (gS.length == 1) gS = '0' + gS;
    if (bS.length == 1) bS = '0' + bS;

    return '#' + rS + gS + bS;
  }

  private getLuma(color: string): number {
    let colorString = color.replace('#', '');

    let r = parseInt(colorString.substr(0, 2), 16);
    let g = parseInt(colorString.substr(2, 2), 16);
    let b = parseInt(colorString.substr(4, 2), 16);

    return 0.2126 * r + 0.7152 * g + 0.0722 * b;
  }
}
